// src/services/frontendAPI.js
// Frontend API: only calls backend endpoints, never uses credentials or PocketBase directly

const apiUrl = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001'; // Adjust if your backend runs on a different port

export async function fetchDemoRecords() {
    const res = await fetch(`${apiUrl}/api/pocketbase-demo`);
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

export async function addDemoRecord(data) {
    const res = await fetch(`${apiUrl}/api/pocketbase-demo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

export async function updateDemoRecord(id, data) {
    const res = await fetch(`${apiUrl}/api/pocketbase-demo/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

export async function removeDemoRecord(id) {
    const res = await fetch(`${apiUrl}/api/pocketbase-demo/${id}`, {
        method: 'DELETE'
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

// --- TASKS API ---
export async function fetchTasks() {
    const res = await fetch(`${apiUrl}/api/tasks`);
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

export async function addTask(data) {
    console.log("Sending task data:", data); // Add this
    const res = await fetch(`${apiUrl}/api/tasks`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    console.log(res);
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

export async function updateTask(id, data) {
    const res = await fetch(`${apiUrl}/api/tasks/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

export async function deleteTask(id) {
    const res = await fetch(`${apiUrl}/api/tasks/${id}`, {
        method: 'DELETE'
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

// --- CIVS API ---
export async function fetchCivs() {
    const res = await fetch(`${apiUrl}/api/civs`);
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

export async function addCiv(data) {
    const res = await fetch(`${apiUrl}/api/civs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

export async function updateCiv(id, data) {
    const res = await fetch(`${apiUrl}/api/civs/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

export async function removeCiv(id) {
    const res = await fetch(`${apiUrl}/api/civs/${id}`, {
        method: 'DELETE'
    });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    return res.json();
}

// Add similar wrappers for rooms as needed, calling backend endpoints only
